export const defaultTheme = {
  companyName: 'Example Company',
  titlePrefix: '',
  globals: {
    name: 'default',
    fontFamily: 'Inter',
    fontFamilyHeadline: 'Inter',
    bgColor: 'rgba(230, 230, 230, 1)',
    linkColor: 'rgba(125, 81, 218, 1)',
    linkColorHover: 'rgba(6, 83, 182, 1)',
    checkboxColor: 'rgba(0, 0, 0, 1)',
    checkboxColorActive: 'rgba(0, 0, 0, 1)',
  },
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '40px 60px 60px',
    borderRadius: '0px',
    border: '1px solid rgba(230, 230, 230, 1)',
    boxShadow: '',
    margin: '0 auto',
    color: 'rgba(38, 38, 38, 1)',
  },
  documentCheckbox: {
    iconColor: 'rgba(125, 81, 218, 1)',
    iconHover: 'rgba(28, 105, 212, 0.6)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '0px',
    fontSize: '28px',
    focusColor: 'rgba(125, 81, 218, 1)',
    bgColor: 'rgba(250, 250, 250, 1)',
    focusBgColor: '#ffffff',
    fontColor: 'rgba(38, 38, 38, 1)',
    loadingColor: 'rgba(125, 81, 218, 1)',
  },
  pdfViewer: {
    pageBackground: 'rgba(255, 255, 255, 1)',
    canvasWidth: '495',
    containerPadding: '',
    containerBorder: '1px solid rgba(235, 235, 235, 1)',
    navigationTop: '',
    navigationLeft: '',
    navigationRight: '',
    navigationBottom: '',
    navigationBgColor: 'rgba(242, 242, 242, 1)',
    navigationBorderRadius: '0px',
    navigationPadding: '8px',
    navigationBoxShadow: '',
    navigationButtonBgColor: 'transparent',
    navigationButtonBorder: '1px solid rgba(110, 110, 110, 0.4)',
    navigationButtonColor: 'rgba(38, 38, 38, 1)',
    navigationButtonBgColorHover: 'rgba(125, 81, 218, 1)',
    navigationButtonBorderHover: '1px solid rgba(125, 81, 218, 1)',
    navigationButtonColorHover: 'rgba(255, 255, 255, 1)',
    navigationButtonPadding: '0px 5px',
    navigationButtonColorDisabled: 'rgba(149, 149, 149, 1)',
    navigationButtonBgColorDisabled: 'rgba(228, 228, 228, 1)',
    navigationButtonBorderDisabled: '1px solid rgba(230, 230, 230, 1)',
    navigationSpacerColor: 'rgba(180, 180, 180, 1)',
    searchTop: '',
    searchLeft: '',
    searchRight: '',
    searchBottom: '',
    searchBgColor: 'rgba(242, 242, 242, 1)',
    searchBorderRadius: '0px',
    searchPadding: '8px',
    searchBoxShadow: '',
    searchColor: 'rgba(38, 38, 38, 1)',
    searchFontSize: '',
    searchInputRadius: '0px',
    searchInputHeight: '',
    searchInputColor: '',
    searchInputBgColor: '',
    searchInputBgColorFocus: 'rgba(255, 255, 255, 1)',
    searchInputBorder: '1px solid rgba(210, 210, 210, 1)',
    searchInputFocusBorder: '1px solid rgba(210, 210, 210, 1)',
    searchInputFocusOutline: '2px solid rgba(125, 81, 218, 1)',
    searchInputPadding: '',
  },
  button: {
    bgColor: '#fff',
    borderRadius: '100px',
    color: '#0071f3',
    bgColorHover: '#f8f7fa',
  },
  proceedButton: {
    bgColor: '#0071f3',
    padding: '10px 44.5px',
    borderRadius: '100px',
    width: 'auto',
    border: 'none',
    boxShadow: 'none',
    boxShadowFocus: '0px 0px 0px 3px rgba(0, 113, 243, 0.3)',
    margin: '0',
    color: 'rgba(255, 255, 255, 1) !important',
    colorHover: 'rgba(255, 255, 255, 1) !important',
    bgColorHover: '#4298fb',
    borderHover: 'none',
    bgColorDisabled: '#acb0b5',
    borderDisabled: 'none',
    colorDisabled: 'rgba(255, 255, 255, 1)',
    fontSize: '14px',
    fontWeight: '500',
    fontFamily: 'Inter',
  },
  buttonDisabled: {
    bgColor: '#acb0b5',
    padding: '10px 24px',
    borderRadius: '0px',
    width: 'auto',
    border: 'none',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1) !important',
    colorHover: 'rgba(255, 255, 255, 1) !important',
    bgColorHover: 'rgba(125, 81, 218, 1)',
    borderHover: 'none',
    bgColorDisabled: 'rgba(125, 81, 218, 0.5)',
    borderDisabled: 'none',
    colorDisabled: 'rgba(255, 255, 255, 1)',
    fontSize: '14px',
    fontWeight: '500',
  },
  header: {
    color: 'rgba(38, 38, 38, 1)',
    fontSize: '1.625rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  symbol: {
    primary: 'rgba(125, 81, 218, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(242, 242, 242, 1)',
  },
  textInput: {
    bgColor: 'white',
    padding: '10px 16px',
    borderRadius: '4px',
    border: '1px solid #C6C3C3',
    boxShadow: 'none',
    margin: '0',
    color: 'gray',
    colorFocus: 'rgba(38, 38, 38, 1)',
    bgColorFocus: 'white',
    borderFocus: '1px solid #0071F3',
    bgColorDisabled: 'silver',
    borderDisabled: 'gray',
    colorDisabled: 'white',
    fontSize: '14px',
    fontWeight: '400',
    outline: '2px solid rgba(125, 81, 218, 1)',
    errorColor: '#d91111',
  },
  selectInput: {
    borderRadius: '1px',
    borderWidth: '1px',
    border: '1px solid #C6C3C3',
    borderFocus: '1px solid #0071F3',
    outline: '2px solid rgba(125, 81, 218, 1)',
    borderColorFocus: '#0071F3',
    backgroundColorSelected: '#0071F3',
    backgroundColorFocus: 'rgba(208, 227, 255, 1)',
    indicatorColorFocus: 'black',
    indicatorColorHover: '#0071F3',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
    fontSize: '14px',
  },
  brandBar: {
    bgColor: 'white',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily: "'MINI Sans Serif', sans-serif;",
    fontFamilyHeadline: '"MINI Serif Headline"',
    bgColor: 'rgba(230, 230, 230, 1)',
    linkColor: 'rgba(125, 81, 218, 1)',
    linkColorHover: 'rgba(6, 83, 182, 1)',
    checkboxColor: 'rgba(0, 0, 0, 1)',
    checkboxColorActive: 'rgba(0, 0, 0, 1)',
    backButton: {
      borderColor: 'rgba(220, 220, 220, 1)',
      color: 'gray',
      colorHover: 'rgba(38, 38, 38, 1)',
      disabled: 'silver',
    },
    input: {
      bgColor: 'white',
      padding: '14px',
      borderRadius: '0px',
      border: '1px solid rgba(220, 220, 220, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'gray',
      colorFocus: 'rgba(38, 38, 38, 1)',
      bgColorFocus: 'white',
      borderFocus: '1px solid rgba(220, 220, 220, 1)',
      bgColorDisabled: 'silver',
      borderDisabled: 'gray',
      colorDisabled: 'white',
      fontSize: '14px',
      fontWeight: '400',
      outline: '2px solid rgba(125, 81, 218, 1)',
      errorColor: '#d91111',
    },
    proceedButton: {
      bgColor: 'rgba(125, 81, 218, 1)',
      padding: '14px 40px',
      borderRadius: '0px',
      width: 'auto',
      border: '1px solid rgba(125, 81, 218, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(255, 255, 255, 1) !important',
      colorHover: 'rgba(255, 255, 255, 1) !important',
      bgColorHover: 'rgba(125, 81, 218, 1)',
      borderHover: '1px solid rgba(125, 81, 218, 1)',
      bgColorDisabled: 'rgba(125, 81, 218, 0.5)',
      borderDisabled: '1px solid rgba(125, 81, 218, 0.5)',
      colorDisabled: 'rgba(125, 81, 218, 1)',
      fontSize: '14px',
      fontWeight: '600',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(230, 230, 230, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: '#000',
    borderColor: 'rgba(230, 230, 230, 1)',
    headerColor: 'rgba(38, 38, 38, 1)',
    primaryColor: 'rgba(125, 81, 218, 1)',
    primaryReverseColor: '#FFF',
    secondaryColor: '586374',
    mainHoverColor: 'rgba(125, 81, 218, 1)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    borderRadius: '0px',
    width: '100%',
    padding: '40px 60px 60px',
    boxShadow: '',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '24px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '4px',
    background: 'white',
    barFill: 'rgba(125, 81, 218, 1)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(38, 38, 38, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(67, 21, 128, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: '#048EF8',
    bgColor: '#FBFBFB',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid rgba(125, 81, 218, 1)',
    buttonColorActive: '#000',
  },
  topBar: {
    bgColor: '#048EF8',
  },
  onboardingWizard: {
    upperCase: true,
    colorCurrent: '#048EF8',
    // CATEGORY
    colorCategoryName: '#A19EAD',
    colorCategoryNameActive: '#272142',
    // CATEGORY ORB
    colorCategoryOrb: '#C6C3C3',
    borderColorCategoryOrb: '#C6C3C3',
    bgColorCategoryOrb: '#F5F4F3',
    // CATEGORY ORB ACTIVE
    colorCategoryOrbActive: '#048EF8',
    borderColorCategoryOrbActive: '#048EF8',
    bgColorCategoryOrbActive: '#fff',
    // CATEGORY ORB DONE
    colorCategoryOrbDone: '#fff',
    borderColorCategoryOrbDone: '#048EF8',
    bgColorCategoryOrbDone: '#048EF8',
    // DIVIDER
    bgColorDivider: '#F5F4F3',
    borderColorDivider: '#C6C3C3',
    bgColorDividerDone: '#048EF8',
    // STEP
    colorStepName: '#A19EAD',
    colorStepNameActive: '#048EF8',
    colorStepNameDone: '#2B253A',
    // STEP ORB
    colorStepOrb: '#767676',
    borderColorStepOrb: '#C6C3C3',
    bgColorStepOrb: '#F5F4F3',
    // STEP ORB ACTIVE
    colorStepOrbActive: '#048EF8',
    borderColorStepOrbActive: '#048EF8',
    bgColorStepOrbActive: '#fff',
    // STEP ORB DONE
    colorStepOrbDone: '#fff',
    borderColorStepOrbDone: '#048EF8',
    bgColorStepOrbDone: '#048EF8',
  },
  personCard: {
    nameColor: '#3E4043',
    titleColor: '#4F4E4E',
    signatoryColor: '#048EF8',
  },
  navMenu: {
    color: '#272142',
    colorActive: '#048EF8',
    border: '6px solid #048EF8',
    margin: '24px 0 40px 0',
  },
  inputRadio: {
    onBgColor: '#048EF8',
    onBgColorHover: '#048EF8',
    onIconColor: '#fff',
    offBgColor: '#cdc7be',
    offBgColorHover: '#cdc7be',
    offIconColor: '#fff',
    onIcon: undefined,
    offIcon: undefined,
  },
}
